import { AxiosInstance } from "axios";
import type { GitLabProject } from "./GitLabSourceSettings.types";

export class GitLabSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getProjects(
    boardId: string,
    connectionId: string,
  ): Promise<GitLabProject[]> {
    const response = await this.client.get<GitLabProject[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/gitlab/projects`,
    );

    return response.data;
  }
}
